module.exports = __webpack_public_path__ + "media/img/corporate/refresh-ccw-f78b23de2cf82dee75eca49153ce8ad6.svg";